import type { WistiaPlayerElement } from '@wistia/wistia-player-react'

// The React wrapper assigns the ref before the custom element upgrades; until
// its definition loads the node is a plain element with no player methods.
export const isWistiaPlayerReady = (
  player: unknown,
): player is WistiaPlayerElement =>
  typeof (player as WistiaPlayerElement | null)?.play === 'function' &&
  typeof (player as WistiaPlayerElement | null)?.pause === 'function'

// WebKit rejects a pending play() when a pause() or another play() interrupts
// it, so scroll- and click-driven switching between players rejects routinely.
// Callers do not await the result, so anything else stays unhandled and reaches
// the global handler.
export const playWistiaPlayer = (player: WistiaPlayerElement) =>
  player.play().catch((error: unknown) => {
    if ((error as DOMException | null)?.name !== 'AbortError') throw error
  })
